export var PERMISSIONS;
(function (PERMISSIONS) {
    PERMISSIONS["CUSTOMER_READ"] = "customer.read";
    PERMISSIONS["USERS_READ"] = "users.read";
    PERMISSIONS["ROLES_PERMISSIONS_READ"] = "roles_permissions.read";
})(PERMISSIONS || (PERMISSIONS = {}));
